import { render, staticRenderFns } from "./PhotoFrame.vue?vue&type=template&id=4b26f0c1&"
import script from "./PhotoFrame.vue?vue&type=script&lang=js&"
export * from "./PhotoFrame.vue?vue&type=script&lang=js&"
import style0 from "./PhotoFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports